import { updateConversationList } from './utils'

const conversationsReducer = (state = {}, action) => {

  switch (action.type) {

    case "userConversationsResponse": {
      var {conversations} = action
      return {
        ...state,
        list: conversations
      }

    }
    case "completelogout": {
      return {

      }

    }
    case "conversationContactResponse": {
      var {conversationContactResponse} = action

      var {list} = state

      return {
        ...state,
        list: updateConversationList(list, conversationContactResponse)
      }

    }
    default:
      return state;
  }

}

export default conversationsReducer;


// WEBPACK FOOTER //
// ./src/Components/Conversations/reducer/index.js